$(document).ready(function () {
	$(".cinema__schedule").each(function () {
		var s = $(this);
		var spoilerLen = s.find(".spoiler").length;
		var button = s.find(".cinema__show_more");

		if (spoilerLen >= 5) {
			button.addClass("is-active");
		}
	});

	$("body").on("click", ".cinema__show_more", function () {
		var s = $(this);
		var parent = s.parent();
		var hiddenItems = parent.find(".spoiler:hidden");

		if (hiddenItems.length < 5) {
			$(".cinema__show_more").removeClass("is-active");
		}

		for (var i = 0; i <= 5; i++) {
			$(hiddenItems[i]).slideDown(200);
		}

		return false;
	});

	$(".city-picker").magnificPopup({
		type: "inline",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
	});
});
